import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';


const QuickActions = ({ onEditProfile, onUpdateAvailability, onViewSettings }) => {
  const actions = [
    {
      id: 'edit-profile',
      label: 'Edit Profile',
      description: 'Update your skills and experience',
      icon: 'Edit3',
      color: 'primary',
      onClick: onEditProfile
    },
    {
      id: 'availability',
      label: 'Update Availability',
      description: 'Change your job search status',
      icon: 'Calendar',
      color: 'accent',
      onClick: onUpdateAvailability
    },
    {
      id: 'settings',
      label: 'Account Settings',
      description: 'Privacy and notification preferences',
      icon: 'Settings',
      color: 'secondary',
      onClick: onViewSettings
    },
    {
      id: 'messages',
      label: 'Messages',
      description: 'View employer communications',
      icon: 'MessageCircle',
      color: 'success',
      to: '/messages'
    }
  ];

  return (
    <div className="bg-card rounded-xl p-6 shadow-elevation border border-border">
      <h3 className="text-lg font-semibold text-foreground mb-4">Quick Actions</h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {actions?.map((action) => {
          const ActionComponent = action?.to ? Link : 'button';
          
          return (
            <ActionComponent
              key={action?.id}
              to={action?.to}
              onClick={action?.onClick}
              className="flex items-center space-x-3 p-4 rounded-lg border border-border hover:border-muted-foreground/50 hover:shadow-elevation transition-all text-left"
            >
              <div className={`h-10 w-10 rounded-lg bg-${action?.color}/10 flex items-center justify-center flex-shrink-0`}>
                <Icon name={action?.icon} size={20} className={`text-${action?.color}`} />
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="text-sm font-medium text-foreground">{action?.label}</h4>
                <p className="text-xs text-muted-foreground mt-1">{action?.description}</p>
              </div>
              <Icon name="ChevronRight" size={16} className="text-muted-foreground" />
            </ActionComponent>
          );
        })}
      </div>
    </div>
  );
};

export default QuickActions;